export enum CustomerOptionalItem {
  CustomerNumber = 'customerNumber',
  LanguageAndCurrency = 'languageAndCurrency',
  PaymentTerm = 'paymentTerm',
}
